import { genericRoute } from 'utils/routeUtils';

import BoxingHomePage from './containers/BoxingHomePage';
import BoxingNav from './nav/BoxingNav';

export default genericRoute(BoxingHomePage, BoxingNav, 'boxing');



// WEBPACK FOOTER //
// ./modules/Boxing/routes.js